module.exports = __webpack_public_path__ + "img/welfare-8.f204d8ec.png";